import React, { useState } from 'react';
import {
  Button,
  Popover,
  Paper,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import {
  TranslateArticlePayload,
  useTranslateArticle
} from 'src/hooks/useTranslateArticle';

const options = [
  { label: 'English', value: 'en' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Chinese', value: 'zh' }
];

interface IProps {
  onClick: () => void;
  loading?: boolean;
  isTranslated?: boolean;
}

const TranslateButton: React.FC<IProps> = ({
  onClick,
  loading = false,
  isTranslated = false
}) => {
  return (
    <>
      <Button
        variant="outlined"
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '6px',
          fontSize: { xs: 11, sm: 14 }
        }}
        onClick={onClick}
        startIcon={<TranslateIcon />}
        disabled={loading}
      >
        {loading
          ? 'Translating...'
          : isTranslated
          ? 'See original'
          : 'Translate'}
      </Button>
    </>
  );
};

export default TranslateButton;
